// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3tWQ0","legacyBtn":"MutateMid_legacyBtn__3Da58"};